import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import Webinars from "@/pages/Webinars";
import { WEBINARS_ENABLED } from "@/config/featureFlags";
import { Navigate } from "@/lib/router-compat";

export const Route = createFileRoute("/webinars/")({
  head: () => seoHead("/webinars/"),
  component: () => (WEBINARS_ENABLED ? <Webinars /> : <Navigate to="/learn" replace />),
});